import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

const SelectInput = props => {

    const { label,
    name,
    value,
    options,
    variant='outlined',
    size='small',
    fullWidth=true,
    disabled=false,
    margin='none',
    multiple=false,
    error,
    onBlur,
    onChange,
    inputProps
  } = props;
  return (
    <FormControl
      variant="standard"
      fullWidth={fullWidth}
      size={size || 'medium'}>
      <InputLabel id='select-label' style={{ margin: '-5px 15px', position: 'absolute' }} >{label}</InputLabel>
      <Select
        labelId='select-label'
        label={label}
        name={name}
        value={value}
        variant={variant || 'outlined'}
        fullWidth={fullWidth}
        error={error}
        onBlur={onBlur}
        onChange={onChange}
        margin={margin || 'none'}
        multiple={multiple}
        size={size}
        disabled={disabled}
        inputProps={inputProps}
      >
        {options.map((option, idx) => {
          const value = option.value ? options.value : option;
          const key = option.key ? `key-${option.key}-${idx}` : `key-${option}-${idx}`;
          const display = option.display ? option.display : option;
          return <MenuItem key={key} value={value}>
            {display}
          </MenuItem>;
        })}
      </Select>
    </FormControl>
  );
};
SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selected: PropTypes.string,
  controlFunc: PropTypes.func,
  placeholder: PropTypes.string
};

export default SelectInput;
